
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ListDialog extends SiteEntityDialog<ListRow, any> {
        protected getFormKey() { return ListForm.formKey; }
        protected getIdProperty() { return ListRow.idProperty; }
        protected getLocalTextPrefix() { return ListRow.localTextPrefix; }
        protected getNameProperty() { return ListRow.nameProperty; }
        protected getService() { return ListService.baseUrl; }

        protected form = new ListForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 380;
            this.form.Items.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.Items.listCode = this.entity.ListCode;
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            this.form.Items.element.css('min-height', Math.max(window.outerHeight - 740, 150) + 'px');
            this.form.Items.element.triggerHandler('layout');
        }

    }
}